import { render, staticRenderFns } from "./TipoInput.vue?vue&type=template&id=14ea6f34"
import script from "./TipoInput.vue?vue&type=script&lang=js"
export * from "./TipoInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports